import { useContext } from 'react'
import { NewSapBarcodeUnseenCountContext } from 'context/newSapBarcodeUnseenCountContext'

const useNewSapBarcodeUnseenCount = () => {
  const context = useContext(NewSapBarcodeUnseenCountContext)

  if (context === undefined) {
    throw new Error(
      'useNewSapBarcodeUnseenCount must be used within a NewSapBarcodeUnseenCountProvider',
    )
  }

  return context
}

export default useNewSapBarcodeUnseenCount
